<div class="editor-container" [class.hidden]="viewerHidden()" [attr.aria-hidden]="viewerHidden()">
  <div #pdfViewerContainer style="height: 63vh"></div>
</div>
@let savingState = this.annotationSavingState();
@if (savingState?.state === 'saving' || savingState?.state === 'failed') {
  <div
    class="saving-status mat-elevation-z8"
    [class.saving]="savingState?.state === 'saving'"
    [class.failed]="savingState?.state === 'failed'"
    (click)="$event.stopPropagation()"
  >
    @switch (savingState?.state) {
      @case ('saving') {
        Saving annotations…
      }
      @case ('failed') {
        <span>Saving failed.</span>
        @if (this.secondsUntilRetry()) {
          <span> Retrying in {{ this.secondsUntilRetry() }} seconds.</span>
        }
      }
    }
  </div>
}
@if (showSpinner()) {
  <div class="loading-spinner-container">
    <mat-spinner color="primary" diameter="80"></mat-spinner>
  </div>
}
@if (hasError()) {
  <div class="error-container">
    <div>
      <hugeicons-icon [size]="80" color="currentColor" [icon]="AlertSquareIcon"></hugeicons-icon>
    </div>
    @if (pdfDocumentErrorMessage()) {
      <div class="error-message">
        {{ pdfDocumentErrorMessage() }}
      </div>
    }
    @if (initialAnnotationsErrorMessage()) {
      <div class="error-message">
        {{ initialAnnotationsErrorMessage() }}
      </div>
    }
    <div>
      <button mat-raised-button color="primary" (click)="retryLoading()">Retry</button>
    </div>
  </div>
}
